import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {ICountrySearch} from './../../../../shared/services/configuration/countries/dtos/country-search';
import {IPaginateProducts} from 'src/shared/common-dtos/get-all-paginate';
import {INDEX_PAGE_SIZE_DEFAULT} from 'src/shared/constants/AppConst';

interface CountryInitialState {
  countrySearch: ICountrySearch;
  regionId: string | null;
  selectedRowKeys: string[];
  tableLoading: boolean;
  regionsTableLoading: boolean;
  isRegionModalOpened: boolean;
  paginate: IPaginateProducts;
}

const initialState: CountryInitialState = {
  countrySearch: {
    countryName: '',
  },
  regionId: null,
  selectedRowKeys: [],
  tableLoading: false,
  regionsTableLoading: false,
  isRegionModalOpened: false,
  paginate: {
    Page: 1,
    PageSize: INDEX_PAGE_SIZE_DEFAULT,
  },
};

const countrySlice = createSlice({
  name: 'country',
  initialState: initialState,
  reducers: {
    setCountrySearch: (state, action) => {
      state.countrySearch = {...state.countrySearch, ...action.payload};
    },
    resetCountrySearch: (state) => {
      state.countrySearch = {...state.countrySearch, ...{countryName: ''}};
    },
    setCountrySelectedRowKeys: (state, action) => {
      state.selectedRowKeys = [...action.payload];
    },
    setCountryTableLoading: (state, action) => {
      state.tableLoading = action.payload;
    },
    setRegionTableLoading: (state, action) => {
      state.regionsTableLoading = action.payload;
    },
    setCountryRegionId: (state, action) => {
      state.regionId = action.payload;
    },
    openRegionModal: (state) => {
      state.isRegionModalOpened = !state.isRegionModalOpened;
    },
    onPaginateionSearch: (state) => {
      state.paginate = {
        ...state.paginate,
        Page: 1,
      };
    },
    onPaginateionChange: (state, action: PayloadAction<IPaginateProducts>) => {
      state.paginate = {
        Page: action.payload.Page,
        PageSize: action.payload.PageSize,
      };
    },
  },
});

export const {
  setCountrySearch,
  resetCountrySearch,
  setCountrySelectedRowKeys,
  setCountryTableLoading,
  setRegionTableLoading,
  setCountryRegionId,
  openRegionModal,
  onPaginateionSearch,
  onPaginateionChange,
} = countrySlice.actions;
export default countrySlice.reducer;
